import React from 'react'
import EmptyState from '../../../../components/elements/EmptyState'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import { Link } from 'react-router-dom'

const TimeTables = () => {
  
  return (
    <>
      <div className='w-full'>
        <div className="w-full mx-auto flex items-center justify-between">
          <div className='w-8/12'>
              <h4 className='font-medium text-lg mb-3 text-gray-400'>Academic Timetables</h4>
              <div className='w-2/3'>
                  <p className='text-gray-500 my-3 text-sm'>
                      Below is a list of academic timetables for the college
                  </p>
              </div>
          </div>
          <div className='w-4/12 flex flex-row-reverse'>
              <Link to={`onboard-new-staff`} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                  <PlusIcon className='w-5 h-5' /> Create timetable
              </Link>
          </div>
        </div>


        {/* {staffSelector?.loadingStaff ? 
          <Loader />
          : */}
          <>
            {/* {staffSelector?.staffMembers?.staff?.length > 0 ? 
              <div className=''>
                {view === 'grid' && 
                  <>
                    <div className='mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-8'>
                      {staffSelector?.staffMembers?.staff?.map((student, studentIndex)=>(
                        <div key={studentIndex}>
                          <StudentCard student={student} />
                        </div>
                      ))}
                    </div>
                    <Pagination 
                      pagination={{
                        perPage, 
                        page,
                        totalItems: staffSelector?.staffMembers?.total,
                      }} 
                      changePage={setPage} 
                      updatePerPage={setPerPage}
                    />
                  </>
                }
                {view === 'list' && <div className='w-full'>
                  <DataTable
                    tableHeaders={tableHeadersFields(cleanUpTableData(staffSelector.staffMembers.staff)[0]).headers} 
                    tableData={cleanUpTableData(staffSelector.staffMembers?.staff)} 
                    columnWidths={columnWidths}
                    columnDataStyles={columnDataStyles}
                    allFields={tableHeadersFields(cleanUpTableData(staffSelector.staffMembers?.staff)[0]).fields}
                    onSelectItems={()=>{}}
                    tableOptions={tableOptions}
                    pagination={{
                        perPage, 
                        page,
                        totalItems: staffSelector.staffMembers.total,
                    }}
                    onSelectSingle={()=>{}}
                    changePage={setPage}
                    updatePerPage={setPerPage}
                  />
                </div>
                }
              </div>
              :  */}
              <div className='mt-24 w-1/2 mx-auto'>
                <EmptyState emptyStateText={`No academic timetables have been created yet. Please create one by clicking on "Create Timetable" above`} />
              </div>

            {/* } */}
          </>
        {/* } */}
      </div>
    </>
  )
}

export default TimeTables